export default "__VITE_ASSET__BRnszB6a__"